// extracted by mini-css-extract-plugin
export default {"iconButton":"ToolbarButton-module__iconButton--o0jFl"};